<template>
	<reportFormWrap
		ref="reportFormWrap"
		:reportid="reportid"
		:orderMenu="orderMenu"
		:settingCols="settingCols"
		:getFiltersParams="getFiltersParams"
		:reportFormUrl="reportFormUrl"
		:getCustomThroughParams="getCustomThroughParams">
		<FiltersBox slot="filters" ref="filters" @inputEnter='inputEnter'></FiltersBox>
	</reportFormWrap>
</template>

<script>
import { cols } from '@/js/reportform/shopSummary.js'
import { orderMenu } from '@/js/reportform/reportformCommon.js'
import reportFormWrap from '@/components/reportform/common/ReportFormWrap.vue'
import FiltersBox from '@/components/reportform/shopSummary/FiltersBox.vue'
export default {
	name: 'shopSummary',
	components: {
		reportFormWrap,
		FiltersBox
	},
	data () {
		return {
			reportid: 'DPHZ_121040',
			settingCols: cols,
			reportFormUrl: `${this.$fxBaseApi.urlQIVShop}/reportScheme/businessShopSaleSumReport `,
			orderMenu: orderMenu
		}
	},
	mounted () {
		this.$refs.reportFormWrap.initReportForm()
	},
	methods: {
		inputEnter () {
			return this.$refs.reportFormWrap.searchHandler()
		},
		getFiltersParams () {
			return this.$refs.filters.getFiltersParams()
		},
		getCustomThroughParams () {
			return this.$refs.filters.getFiltersDate()
		}
	}
}
</script>
<style lang="stylus" scoped>
</style>
